<template>
    <van-popup v-model="show" mode="center">
        <div class="content" :class="classObj">
            <div class="header">
                <div>{{ $t('weeklySalary.upBonusTitle') }}</div>
                <div v-if="item.type == 'week'">({{ $t('weeklySalary.recordTabWeekly') }})</div>
                <div v-else>({{ $t('weeklySalary.sectionTitle') }})</div>
                <div class="close">
                    <i class="iconfont icon-s-cuowu-guanbi" @click="close"></i>
                </div>
            </div>
            <div class="main_content">
                <div class="desc_txt">
                    {{ $t('weeklySalary.upBonusDesc1') }}
                    <span class="plain">{{ formatCurrency(item.amount, 2) }}</span>,
                    {{ $t('weeklySalary.upBonusDesc2') }}
                    <span class="plain">{{ formatCurrency(item.upgradeBonusLevelUpRechargeAmt, 2) }}</span>,
                    {{ $t('weeklySalary.upBonusDesc3') }}
                    <span class="highlight">{{ formatCurrency(item.levelUpAmount, 2) }}</span>!
                </div>
                <div class="reward_compare">
                    <div class="super_card">
                        <div>
                            <div class="card_label">{{ $t('weeklySalary.upBonusSuperDouble') }}</div>
                            <div class="super_amount">{{ CurrencyType }}{{ formatAmount(item.levelUpAmount, 2) }}</div>
                        </div>
                        <img class="light" src="@/assets/common/faguang.png" />
                        <img class="coin" src="@/assets/common/gold1.png" />
                    </div>
                    <div class="claim-center">
                        <div class="multiple_mark">
                            <img src="@/assets/common/up.png" />
                            <div>x{{ multiple }}</div>
                        </div>
                    </div>
                    <div class="normal_card">
                        <div>
                            <div class="card_label">{{ $t('weeklySalary.upBonusCommon') }}</div>
                            <div class="normal_amount">{{ CurrencyType }}{{ formatAmount(item.amount, 2) }}</div>
                        </div>
                        <img class="coin" src="@/assets/common/gold.png" />
                    </div>
                </div>
                <div class="btn_group">
                    <div class="primary" @click.stop="toDeposit">{{ $t('weeklySalary.claim') }} {{
                        formatAmount(item.levelUpAmount, 2) }}</div>
                    <div class="secondary" @click.stop="onReceive">{{ $t('weeklySalary.claim') }} {{
                        formatAmount(item.amount, 2) }}</div>
                </div>
            </div>
        </div>
    </van-popup>
</template>

<script>
import { mapState } from 'vuex'
export default {
    data() {
        return {
            isFirstReload: true,
            show: false,
            item: {},
            isCanReceive: true
        }
    },
    computed: {
        ...mapState({
            device: state => state.app.device
        }),
        classObj() {
            return {
                mobile: this.device === 'mobile'
            }
        },
        sysConfig() {
            return this.$store.getters.sysConfig
        },
        multiple() {
            const num = Number(this.item.amount) > 0 ? Number(this.item.levelUpAmount) / Number(this.item.amount) : 0
            return Math.round(num * 100) / 100
        }
    },
    methods: {
        open(item) {
            this.item = item
            this.show = true
        },
        close() {
            this.show = false
        },
        toDeposit() {
            const params = { type: 'deposit', depositType: this.item.depositType, rewardRecordId: this.item.rewardRecordId, upRechargeAmt: this.item.upgradeBonusLevelUpRechargeAmt }
            this.onNavTo({ url: '/wallet', type: 'get', params })
        },
        onReceive() {
            this.$emit('getNormalReward', this.item)
        }
    }
}
</script>

<style scoped lang="scss">
@import '@/common/styles/viriables.scss';

$weekly-salary-popup-shell-bg: $bg-home-popup-shell-color;
$weekly-salary-popup-shell-border: $border-home-popup-color;
$weekly-salary-popup-shell-shadow: 0 .18rem .42rem rgba($bg-shell-color, .46);
$weekly-salary-popup-title-color: $font-title-color;
$weekly-salary-popup-close-color: rgba($font-component-surface-bright-color, .84);
$weekly-salary-popup-highlight-color: $font-component-warning-strong-color;
$weekly-salary-popup-super-bg: $bg-component-deep-color;
$weekly-salary-popup-super-shadow: inset 0 0 17px rgba($font-component-gold-base-color, .4);
$weekly-salary-popup-super-border: $font-component-gold-bright-color;
$weekly-salary-popup-multiple-color: $font-component-gold-cream-color;
$weekly-salary-popup-secondary-bg: rgba($font-title-color, .1);
$weekly-salary-popup-secondary-text: $font-title-color;

.van-popup {
    background: transparent;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    width: 100%;

    .content {
        background: rgba(50, 6, 79, 0.9);
        border: .02rem solid #F912AC;
        box-shadow: inset 0px 0px 10px 0px rgba(249, 18, 172, 0.8);
        border-radius: .436rem;
        width: 94%;
        max-width: 424px;
        min-height: 500px;
        box-sizing: border-box;
        position: relative;
        overflow: hidden;
        display: flex;
        flex-direction: column;

        &.mobile {

            .main_content {
                padding: .24rem 0;
                padding-bottom: 0;
            }

            .super_card {
                width: 86%;
            }

            .normal_card {
                width: 86%;
            }

        }

        .header {
            height: .98rem;
            padding: .36rem 0 0 .18rem;
            position: relative;

            &>div:first-child {
                flex: 1;
                text-align: center;
                font-size: .54rem;
                font-weight: bold;
                color: $weekly-salary-popup-title-color;
            }

            &>div:nth-child(2) {
                flex: 1;
                text-align: center;
                font-size: .28rem;
                color: rgba(255, 255, 255, 0.65);
            }

            .close {
                color: $weekly-salary-popup-close-color;
                font-size: .68rem;
                font-weight: 100;
                height: 1.2rem;
                width: 1.2rem;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                position: absolute;
                top: -.1rem;
                right: -.1rem;

                .iconfont {
                    font-size: .48rem;
                }
            }
        }

        .main_content {
            overflow: auto;
            padding: 0;
            margin: .24rem .3rem .3rem;
            margin-top: 0;
            border-radius: .24rem;

            .desc_txt {
                margin-top: .6rem;
                color: #C899E7;
                font-size: .3rem;
                line-height: .4rem;
                text-align: center;

                .plain {
                    font-weight: bold;
                }

                .highlight {
                    color: #FFCE2D;
                    font-weight: bold;
                }
            }

            .reward_compare {
                width: 100%;
                margin-top: .5rem;
            }

            .super_card {
                width: 80%;
                background: rgba(41, 6, 71, 0.4);
                box-shadow: inset 8px 8px 30px 0px rgba(255, 255, 255, 0.2), inset -8px -8px 30px 0px rgba(255, 255, 255, 0.2);
                border-radius: .35rem;
                border: 2px solid #FFCE2D;
                position: relative;
                display: flex;
                margin: 0 auto;
                align-items: center;
                justify-content: space-between;

                &>div {
                    position: relative;
                    z-index: 2;
                    padding: .28rem;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-direction: column;

                    .card_label {
                        font-size: .34rem;
                        color: $weekly-salary-popup-title-color;
                        line-height: .34rem;
                        font-weight: bold;
                    }
                }

                .light {
                    width: 2.36rem;
                    height: auto;
                    position: absolute;
                    top: -.2rem;
                    right: -.1rem;
                    z-index: 10;
                    animation: drawBgImg 20s linear infinite;
                }

                .coin {
                    width: 1.56rem;
                    height: auto;
                    position: absolute;
                    top: .1rem;
                    right: .25rem;
                    z-index: 11;
                }

                @keyframes drawBgImg {
                    0% {
                        -webkit-transform: rotate(0deg);
                        transform: rotate(0)
                    }

                    to {
                        -webkit-transform: rotate(1turn);
                        transform: rotate(1turn)
                    }
                }

                .super_amount {
                    margin-top: .18rem;
                    font-size: .58rem;
                    line-height: .68rem;
                    font-weight: bold;
                    color: #FFCE2D;
                    text-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3);
                }
            }

            .normal_card {
                border-radius: .34rem;
                text-align: center;
                width: 80%;
                background: rgba(41, 6, 71, 0.4);
                box-shadow: inset 8px 8px 30px 0px rgba(255, 255, 255, 0.2), inset -8px -8px 30px 0px rgba(255, 255, 255, 0.2);
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin: 0 auto;
                position: relative;
                top: -1.2rem;
                z-index: 5;

                &>div {
                    position: relative;
                    z-index: 2;
                    padding: .28rem;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-direction: column;

                    .card_label {
                        font-size: .34rem;
                        color: $weekly-salary-popup-title-color;
                        line-height: .34rem;
                    }
                }

                .coin {
                    width: 88px;
                    height: 88px;
                    vertical-align: middle;
                    margin: .1rem 0;
                }

                .normal_amount {
                    margin-top: .18rem;
                    font-size: .5rem;
                    line-height: .6rem;
                    font-weight: bold;
                    text-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3);
                }
            }

            .claim-center {
                display: flex;
                justify-content: center;
                position: relative;
                z-index: 10;
            }

            .multiple_mark {
                width: fit-content;
                animation: doubleArrowToLeft-24a7b3f5 1.3s ease-in-out infinite;
                position: relative;
                top: -.5rem;

                &>img {
                    width: 1.7rem;
                    height: auto;
                    flex-shrink: 0;
                }

                &>div {
                    font-size: .48rem;
                    color: $weekly-salary-popup-multiple-color;
                    font-weight: 700;
                    text-align: center;
                    -webkit-text-stroke: 2px #2F064A;
                    position: absolute;
                    left: .45rem;
                    bottom: .5rem;
                }

                @keyframes doubleArrowToLeft-24a7b3f5 {

                    0%,
                    to {
                        transform: translate(0, 5%)
                    }

                    50% {
                        transform: translate(0, -5%)
                    }
                }
            }

            .btn_group {
                margin-top: -1.2rem;

                &>div {
                    height: 1rem;
                    width: fit-content;
                    border-radius: 1rem;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: .48rem;
                    cursor: pointer;
                    padding: 0 .7rem;
                    margin: .4rem auto;

                    &.primary {
                        background: linear-gradient(180deg, #FFD426 0%, #FF7E13 100%);
                        color: #490E05;
                        font-weight: bold;
                    }

                    &.secondary {
                        background: #32064F;
                        box-shadow: inset 0px 0px 10px 0px rgba(249, 18, 172, 0.8);
                        border: 2px solid #F912AC;
                        color: rgba(255, 255, 255, 0.85);
                        font-size: .45rem;
                    }
                }
            }
        }
    }
}
</style>
